import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from "@/shared/components/ui/empty";
import type { Company } from "@/services/backend/company/company";
import { PutCompanyDialog } from "./put-company-dialog";
import { CompanyDataCard } from "./company-data-card";

interface CompanyProfileCardProps {
  company?: Company;
}

export function CompanyProfileCard({ company }: CompanyProfileCardProps) {
  if (!company) {
    return (
      <Empty>
        <EmptyHeader>
          <EmptyTitle>Kein Unternehmen angelegt</EmptyTitle>
          <EmptyDescription>
            Legen Sie den Namen des Unternehmens an, welches die Laborsoftware
            verwendet.
          </EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <PutCompanyDialog />
        </EmptyContent>
      </Empty>
    );
  }

  return <CompanyDataCard company={company} />;
}
